import React, { useState, useEffect, useCallback } from 'reactn';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import { setAccessToken, setRefreshToken, setUsername } from '../../actions/auth';
import storer from '../../store';

// import history from '../History/History';

const { store } = storer();
const axios = require('axios').default;

const redirectToLogin = () => {
    window.location.href = '/';
};
export const redirectToSecure = () => {
    window.location.href = '/secure';
};
const redirectToLoading = () => {
    window.location.href = '/secure/loading';
};

export const Login = (tokens) => {
    store.dispatch(setAccessToken(tokens.access_token));
    store.dispatch(setRefreshToken(tokens.refresh_token));
    store.dispatch(setUsername(tokens.username));

    redirectToLoading();
};

export const Logout = () => {
    // eslint-disable-next-line
    store.dispatch(setAccessToken(null));
    store.dispatch(setRefreshToken(null));
    store.dispatch(setUsername(null));

    redirectToLogin();
};

export function Api() {
    const { accessToken, username, refreshToken } = store.getState().auth;
    const commons = {
        Authorization: `Bearer ${accessToken}`
    };

    const instance = axios.create({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        // responseType: 'json',
        headers: {
            common: accessToken ? commons : null
        }
    });
    instance.interceptors.request.use((request) => {
        if (accessToken) {
            request.headers.Authorization = `Bearer ${accessToken}`;
        }
        return request;
    });

    createAuthRefreshInterceptor(instance, (failedRequest) => {
        instance
            .post(`${process.env.REACT_APP_API_BASE_URL}/cognito/${username}/refresh`, {
                refresh_token: refreshToken
            })
            .then((tokenRefreshResponse) => {
                Login({
                    access_token: tokenRefreshResponse.data.access_token,
                    refresh_token: tokenRefreshResponse.data.refresh_token,
                    username
                });
                // eslint-disable-next-line
                failedRequest.headers.Authentication = `Bearer ${tokenRefreshResponse.data.access_token}`;
                return Promise.resolve();
            })
            .catch(() => {
                Logout();
            });
    });
    return instance;
}

export const refreshTokens = () => {
    const { username, refreshToken } = store.getState().auth;

    Api
        .post(`${process.env.REACT_APP_API_BASE_URL}/cognito/${username}/refresh`, {
            refresh_token: refreshToken
        })
        .then(tokenRefreshResponse => ({
            access_token: tokenRefreshResponse.data.access_token,
            refresh_token: tokenRefreshResponse.data.refresh_token,
            username
        }))
        .catch((error) => {
            console.log('catch', error.message);
        });
};

export const authenticate = async () => {
    const { refreshToken } = store.getState().auth;

    if (refreshToken) {
        try {
            const tokens = await refreshTokens();
            Login(tokens);

            return true;
        } catch (error) {
            redirectToLogin();
            return false;
        }
    }
    redirectToLogin();
    return false;
};


export function AuthenticatedRoute({
    component,
    exact,
    path,
    basename
}) {
    const { accessToken } = store.getState().auth;

    const isAuthenticated = useCallback(() => !!accessToken, [accessToken]);

    return (
        <Route
            exact={exact}
            path={path}
            basename={basename}
            render={routeProps => (
                isAuthenticated() ? (
                    component(routeProps)
                ) : (
                    <AuthenticateBeforeRender render={() => component} />
                )
            )}
        />
    );
}

AuthenticatedRoute.propTypes = {
    component: PropTypes.func.isRequired,
    exact: PropTypes.bool,
    path: PropTypes.string.isRequired,
    basename: PropTypes.string
};
AuthenticatedRoute.defaultProps = {
    basename: '',
    exact: false
};

/**
 *
 * @param props
 * @returns {null}
 * @constructor
 */
export function AuthenticateBeforeRender(props) {
    const [authenticated, setAuthenticated] = useState(false);

    useEffect(() => {
        authenticate()
            .then((response) => {
                setAuthenticated(response);
            });
    }, []);
    return (
        authenticated ? props.render() : null
    );
}